import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptInjectorService {
  constructor() {}

  /**
   * @param script
   * @param target
   */
  injectFragment(script: string, target: string) {
    if (!script) {
      return;
    }
    const fragment = document.createRange().createContextualFragment(script);

    // document
    //   .getElementById('htmlWithScript')
    //   ?.setAttribute('data-custom', JSON.stringify(this.custom));
    (document.getElementById(target) as any).innerHTML = '';
    document.getElementById(target)?.appendChild(fragment);
  }
}
